import api from './api';
import { downloadBinaryFile } from './fileDownload';

const BADGE_CACHE_PREFIX = 'employee-badges:';

const employeeBadgeService = {
  getDashboard: async () => {
    const response = await api.cachedGet('/employee-badges', {}, {
      cacheKey: `${BADGE_CACHE_PREFIX}dashboard`,
      ttlMs: 15 * 1000
    });
    return response.data;
  },

  getByUser: async (userId) => {
    const response = await api.cachedGet(`/employee-badges/${userId}`, {}, {
      cacheKey: `${BADGE_CACHE_PREFIX}detail:${userId}`,
      ttlMs: 10 * 1000
    });
    return response.data;
  },

  createBadge: async (userId) => {
    const response = await api.post(`/employee-badges/${userId}/create`);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  regenerateQr: async (userId) => {
    const response = await api.post(`/employee-badges/${userId}/regenerate-qr`);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  disableBadge: async (userId) => {
    const response = await api.post(`/employee-badges/${userId}/disable`);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  saveProfile: async (userId, payload) => {
    const response = await api.put(`/employee-badges/${userId}/profile`, payload);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  uploadPhoto: async (userId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/employee-badges/${userId}/photo`, formData);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  deletePhoto: async (userId) => {
    const response = await api.delete(`/employee-badges/${userId}/photo`);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  uploadCompanyLogo: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/employee-badges/company/logo', formData);
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  deleteCompanyLogo: async () => {
    const response = await api.delete('/employee-badges/company/logo');
    api.invalidateCache(BADGE_CACHE_PREFIX);
    return response.data;
  },

  downloadPdf: async (userId) => {
    return downloadBinaryFile(
      api,
      `/employee-badges/${userId}/pdf`,
      `employee-badge-${userId}.pdf`
    );
  },

  verifyToken: async (token) => {
    const response = await api.get(`/employee-badges/verify/${token}`);
    return response.data;
  }
};

export default employeeBadgeService;
